module.exports = __webpack_public_path__ + "static/media/informaticaelettronica.3975252c.png";